import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE, extractFilenameFromHeaders } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { ExportQueryParameters } from '../../common/export/export-query.parameters';
import { ExportResult } from '../../common/export/export-query.result';
import { ExportQuery } from '../../common/export/export.query-base';

export interface UnsettledPaymentsExportParameters extends ExportQueryParameters { }

export class UnsettledPaymentsExportQuery extends ExportQuery<ExportResult> {
    public constructor(parameters: UnsettledPaymentsExportParameters) {
        super(parameters);
    }
}

export class UnsettledPaymentsExportQueryHandlerBase implements QueryHandler<UnsettledPaymentsExportQuery, ExportResult> {
    private static Url = TaggedUrl.join('unsettledPayment/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: UnsettledPaymentsExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns
            }
        };

        const response = await this.http.post<Blob>(UnsettledPaymentsExportQueryHandlerBase.Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });

        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse>response) ?? ''
        };
    }
}
